
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 45.5 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M33.85 55.4h-.109a1.749 1.749 0 01-1.272-.671l-5.819-7.47a7.014 7.014 0 01.578-9.249l.87-.87a7.016 7.016 0 019.247-.577l7.477 5.8a1.751 1.751 0 01.164 2.62l-9.9 9.9a1.748 1.748 0 01-1.236.517zm-.8-16.808a3.506 3.506 0 00-2.478 1.022l-.868.869a3.509 3.509 0 00-.291 4.627l4.6 5.9 7.1-7.1-5.911-4.589a3.487 3.487 0 00-2.152-.729z"}}),_c('path',{staticClass:"a",attrs:{"d":"M28.9 40.551a1.743 1.743 0 01-1.237-.513l-16.35-16.35a1.75 1.75 0 012.475-2.474l16.35 16.349a1.75 1.75 0 01-1.238 2.988zM10.5 17.5a8.75 8.75 0 118.75-8.75 8.76 8.76 0 01-8.75 8.75zm0-14a5.25 5.25 0 105.25 5.25A5.256 5.256 0 0010.5 3.5zm0 52.5a7.008 7.008 0 01-7-7v-7.3A5.259 5.259 0 010 36.75v-10.5a8.775 8.775 0 014.375-7.578 1.75 1.75 0 111.75 3.032A5.265 5.265 0 003.5 26.25v10.5a1.752 1.752 0 001.75 1.75A1.75 1.75 0 017 40.25V49a3.5 3.5 0 007 0v-8.75a1.75 1.75 0 011.75-1.75 1.752 1.752 0 001.75-1.75 1.75 1.75 0 013.5 0 5.259 5.259 0 01-3.5 4.95V49a7.008 7.008 0 01-7 7z"}})])
          )
        }
      }
    